module.exports = __webpack_public_path__ + "img/forget-passMailEN.a6e31e7d.png";